/**
 * Управление темной/светлой темой
 * Поддержка автоматического определения системной темы и сохранения выбора пользователя
 * 
 * Orchestrator модуля theme - загружает подмодули и предоставляет публичный API
 * # ⛓️ CURSOR_ANCHOR:ui:theme-orchestrator
 */

(function() {
  'use strict';

  // Загружаем модули последовательно (IIFE pattern для не-модульного JS)
  // Порядок важен: constants -> storage -> detection -> application -> toggle -> ui -> events -> init

  // Экспортируем публичный API СРАЗУ (до инициализации)
  // Реальные функции будут доступны после загрузки всех модулей
  window.THEME = {
    toggle: function() {
      if (window.THEME_TOGGLE) {
        window.THEME_TOGGLE.toggle();
      }
    },
    set: function(theme) {
      if (window.THEME_TOGGLE) {
        window.THEME_TOGGLE.set(theme);
      }
    },
    get: function() {
      if (window.THEME_STORAGE) {
        return window.THEME_STORAGE.get();
      } else {
        return 'light';
      }
    },
    getEffective: function() {
      if (window.THEME_DETECTION) {
        return window.THEME_DETECTION.getEffective();
      } else {
        return 'light';
      }
    }
  };

  // Также экспортируем глобально для совместимости (используется в onclick)
  window.toggleTheme = function() {
    window.THEME.toggle();
  };

  // Инициализируем при загрузке DOM
  function initializeThemeSystem() {
    if (window.THEME_INIT) {
      window.THEME_INIT.initialize();
    }
  }

  // Пытаемся инициализировать сразу (если DOM уже готов)
  if (document.readyState !== 'loading') {
    setTimeout(initializeThemeSystem, 0);
  } else {
    // Ждем загрузки DOM
    document.addEventListener('DOMContentLoaded', initializeThemeSystem);
  }
})();
